let modelPkgTable = [
  {
    label: "序号",
    prop: "id",
    sortable: 1,
  },
  {
    label: "名称",
    prop: "name",
    sortable: 1
  },
  {
    label: "周期",
    prop: "period"
  },
]

let modelTable = [{
  label: "序号",
  prop: "modelId",
  sortable: 1
},
{
  label: "名称",
  prop: "modelName"
},
{
  label: "考核对象类型",
  prop: "objectType"
},
{
  label: "考核周期",
  prop: "season"
},
{
  label: "指标类型",
  prop: "normId"
},
{
  label: "考核对象",
  prop: "object"
},
{
  label: "考核主体",
  prop: "subject"
},
{
  label: "是否启用",
  prop: "available",
},
{
  label: "评分方式",
  prop: "evaType"
},
]


let modelPkgData = [{
  pkgName: "2021年第二季度共性指标考核",
  period: "2021 第2季度",
  id: 1,
  season: "第二季度",
},
{
  pkgName: "2021年第二季度个性指标考核",
  period: "2021 第1季度",
  id: 1,
  season: "第一季度",
}
]

let modelData = []
// let modelData = [{
//   modelId: 1,
//   modelName: "2021年共性指标考核（科室长）",
//   objType: "个人",
//   season: "季度",
//   normName: "共性指标范围",
//   object: "科长级",
//   subject: ["局长级"],
//   available: "1",
//   evaType: "权重",
//   score: "100",
//   connect: "需要"
// },
// {
//   modelId: 1,
//   modelName: "2020年共性指标考核（科室成员）",
//   objType: "个人",
//   season: "季度",
//   normName: "共性指标范围",
//   object: "科员级",
//   subject: ["科长级"],
//   available: "1",
//   evaType: "权重",
//   score: "100",
//   connect: "需要"
// },
// ]


export {
  modelPkgTable,
  modelTable,
  modelPkgData,
  modelData
}